export default __webpack_public_path__ + "static/media/3048.e24e69a4.jpg";